import { registerDogForm } from './registerDogForm';

export function getDogProfileCompletion(dogData) {
  const allFields = registerDogForm.flatMap((section) => section.fields);
  const totalFields = allFields.length;

  const filledFields = allFields.filter((field) => {
    const value = dogData[field.id];
    return value !== undefined && value !== null && value !== '';
  }).length;

  const percentage = Math.round((filledFields / totalFields) * 100);
  return percentage;
}
